import Form from "./Form";
import checkForm from "./FormValidation";

export default Form;
export { checkForm };
